import React, { useState, useEffect } from 'react';
import { fetchAllTeamsWithMembers } from '../services/span_services';

// Read-only list of the teams for beoordelaars to look at beforehand: each card shows the
// team's logo, name, project, bio and the line-up of members. There is nothing to edit here.

function Spanne() {
  const [spanne, setSpanne] = useState(null); // null while loading
  const [message, setMessage] = useState('');
  const [uitgebrei, setUitgebrei] = useState({}); // span_id -> true (lede oopgevou)

  useEffect(() => {
    fetchAllTeamsWithMembers()
      .then(data => setSpanne(data))
      .catch(err => setMessage('Kon nie spanne laai nie: ' + err.message));
  }, []);

  if (spanne === null) {
    return <div>Laai spanne...</div>;
  }
  if (spanne.length === 0) {
    return (
      <div style={{ color: '#666' }}>
        Daar is nog geen spanne nie. Die admin kan hulle op die Span Bestuur-bladsy byvoeg.
      </div>
    );
  }

  const kaart = {
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '10px',
    padding: '1.1rem',
    marginBottom: '1rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
  };

  return (
    <div>
      <h2 style={{ margin: '0 0 1.25rem 0', color: '#0e1e3b' }}>Spanne</h2>
      {message && (
        <div style={{ backgroundColor: '#a32020', color: 'white', padding: '12px', borderRadius: '6px', marginBottom: '1rem' }}>
          {message}
        </div>
      )}
      {spanne.map(({ team, members }) => {
        const oop = !!uitgebrei[team.span_id];
        const toggleLede = () => setUitgebrei(prev => ({ ...prev, [team.span_id]: !oop }));
        return (
          <div key={team.span_id} style={kaart}>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '10px',
                  backgroundColor: '#f0f0f7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  flexShrink: 0,
                  border: '1px solid #eee'
                }}
              >
                {team.logo ? (
                  <img src={team.logo} alt={`${team.naam}-logo`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <span style={{ fontSize: '2rem', color: '#9a8a78' }}>🥧</span>
                )}
              </div>
              <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                <h3 style={{ margin: '0 0 4px 0', color: '#0e1e3b' }}>{team.naam}</h3>
                {team.projek_beskrywing && (
                  <p style={{ margin: '0 0 6px 0', fontStyle: 'italic', color: '#555' }}>
                    {team.projek_beskrywing}
                  </p>
                )}
                {team.span_bio && <p style={{ margin: '0', color: '#444' }}>{team.span_bio}</p>}
                <button
                  type="button"
                  onClick={toggleLede}
                  style={{
                    marginTop: '8px',
                    padding: '4px 10px',
                    backgroundColor: '#0e1e3b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  {oop ? 'Versteek lede' : `Wys lede (${members.length})`}
                </button>
              </div>
            </div>
            {oop && (
              <div style={{ marginTop: '0.75rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.75rem' }}>
                {members.length === 0 && (
                  <p style={{ margin: 0, color: '#999' }}>Geen lede nog nie.</p>
                )}
                {members.map(lid => (
                  <div
                    key={lid.lid_id}
                    style={{
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      padding: '0.6rem',
                      backgroundColor: '#fafafa',
                      display: 'flex',
                      gap: '0.6rem',
                      alignItems: 'center'
                    }}
                  >
                    {lid.foto ? (
                      <img
                        src={lid.foto}
                        alt={lid.naam}
                        style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                      />
                    ) : (
                      <div
                        style={{
                          width: '44px',
                          height: '44px',
                          borderRadius: '50%',
                          backgroundColor: '#0e1e3b',
                          color: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                          flexShrink: 0
                        }}
                      >
                        {lid.naam ? lid.naam.charAt(0).toUpperCase() : '?'}
                      </div>
                    )}
                    <div style={{ minWidth: 0, textAlign: 'left' }}>
                      <div style={{ fontWeight: 'bold', color: '#0e1e3b' }}>{lid.naam}</div>
                      {lid.bio && <div style={{ fontSize: '0.85rem', color: '#666' }}>{lid.bio}</div>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Spanne;